export default __webpack_public_path__ + "static/364086_0_0-c12d161afb969ad63521d74ee5640d4f.woff2";